export const EMPTY_ALGORITHM = 'Algorithm/EMPTY_ALGORITHM';
export const SET_ALGORITHM = 'Algorithm/SET_ALGORITHM';

export const FETCH_ALGORITHM = 'Algorithm/FETCH_ALGORITHM';
export const FETCH_ALGORITHM_SUCCESS = 'Algorithm/FETCH_ALGORITHM_SUCCESS';
export const FETCH_ALGORITHM_FAILURE = 'Algorithm/FETCH_ALGORITHM_FAILURE';

export const SAVE_ALGORITHM = 'Algorithm/SAVE_ALGORITHM';
export const SAVE_ALGORITHM_SUCCESS = 'Algorithm/SAVE_ALGORITHM_SUCCESS';
export const SAVE_ALGORITHM_FAILURE = 'Algorithm/SAVE_ALGORITHM_FAILURE';



// WEBPACK FOOTER //
// ./src/containers/AlgorithmPage/store/constants.js